<template> 
  <div class="homepage">
    <ButtonGroup class="mb-1 btnGroup">
      <Button @click="page = 1" :type="page == 1 ? 'success' : 'default'">{{ '在线人数' }}</Button>
      <Button @click="page = 2" :type="page == 2 ? 'success' : 'default'">{{ '下注人数' }}</Button>
      <Button @click="page = 3" :type="page == 3 ? 'success' : 'default'">{{ '重复IP列表' }}</Button>
    </ButtonGroup>

    <Row :gutter="8">
      <!-- <Col  class="mb-1">
        <ChartsLiveNumber />
      </Col> -->
      <template v-if="page == 1">
        <Col class="mb-1">
          <ChartsTimeNumber/>
        </Col>
        <Col >
          <ChartsMonthNumber />
        </Col>
      </template>
      <template v-if="page == 2">
        <Col class="mb-1">
          <ChartsBetNumber />
        </Col>
      </template>
      <template v-if="page == 3">
        <Col class="mb-1">
          <IpReMemVue />
        </Col>
      </template>
    </Row>
  </div>
</template>

<style>
/**
 * 默认尺寸为 600px×400px，如果想让图表响应尺寸变化，可以像下面这样
 * 把尺寸设为百分比值（同时请记得为容器设置尺寸）。
 */
.echarts {
  width: 100%;
  height: 100%;
}
</style>

<script>
import ChartsLiveNumber from "./components/ChartsLiveNumber";
import ChartsBetNumber from "./components/ChartsBetNumber";
import ChartsTimeNumber from "./components/ChartsTimeNumber";
import ChartsMonthNumber from "./components/ChartsMonthNumber";
import IpReMemVue from './components/IpReMem.vue';

export default {
  name: 'home',
  components: {
    ChartsLiveNumber,
    ChartsBetNumber,
    ChartsTimeNumber,
    ChartsMonthNumber,
    IpReMemVue
  },
  data () {
    return {
      page: 1
    }
  }
}
</script>
<style lang="scss">
.homepage {
  .btnGroup {
    Button {
      height: 36px;
      width: 84px;
    }
  }
}
.home-Date-input {
  .ivu-input {
    border: 1px solid #f5f7f9;
    background-color: #f5f7f9;
  }
}
.home-smallCard-data {
  text-align: center;
  min-width: 140px;
  width: 100%;
  border-radius: 4px;
  padding: 4px;
  height: 60px;
  box-sizing: border-box;
  &.default {
    border: 1px solid $main-dark-color;
    .home-smallCard-data-title, .home-smallCard-data-content {
      color: $main-dark-color;
    }
  }
  &-title {
    color: #fff;
    font-size: 14px;
    line-height: 1.5
  }
  &-content {
    color: #fff;
    font-size: 20px;
  }
}
</style>